import * as React from 'react';
import * as styles from './OfflineIcon.scss';

export default (props: any) => (
  <img
    className={styles.offline}
    src="https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-offline-new.svg"
    style={props.style}
  />
);



// WEBPACK FOOTER //
// ./components/icons/OfflineIcon/OfflineIcon.tsx